import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/**
 * 로그인한 사용자 — 일렉트론이 IPC 로 넣어 준다.
 *
 * 분리앱은 일렉트론과 origin 이 달라 localStorage 를 공유받지 못하므로,
 * API 인증(Bearer)에 쓰는 token 도 여기로 들어온다 (WindowLayer.handleGetUserInfo 참조).
 */
export type UserState = {
    _id?: string
    token?: string
    phone?: string
    type: number
    name?: string
    gender?: string
    birth?: string

    createdAt?: string
    updatedAt?: string
    photo?: string
    badgeCount: number

    deviceTokens: unknown[]
    deviceInfos: Record<string, unknown>

    HOSPITAL_ID?: string
}

const state: UserState = {
    _id: undefined,
    token: undefined,
    phone: undefined,
    type: 0,
    name: undefined,
    gender: undefined,
    birth: undefined,

    createdAt: undefined,
    updatedAt: undefined,
    photo: undefined,
    badgeCount: 0,

    deviceTokens: [],
    deviceInfos: {},

    HOSPITAL_ID: undefined,
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetUser': async (store: Store, param: Partial<UserState>): Promise<void> => {
        store.commit('MU_SetUser', param)
    },
    'AC_SetHospitalID': (store: Store, HOSPITAL_ID: string): void => {
        store.commit('MU_SetHospitalID', HOSPITAL_ID)
    },
}

const mutations = {
    /** 넘어온 키만 갈아끼운다 — 없는 키는 건드리지 않는다 */
    'MU_SetUser': (state: UserState, param: Partial<UserState>): void => {
        Object.assign(state, param)
    },
    'MU_SetHospitalID': (state: UserState, HOSPITAL_ID: string): void => {
        state.HOSPITAL_ID = HOSPITAL_ID
    },
}

const user: Module<UserState, StoreState> = { state, actions, mutations }

export default user
